<template>
  <div v-if="item.status">
    <v-btn :color="chipColor" x-small @click="openInfo" :loading="loading">
      <v-icon x-small color="white" class="mr-1">mdi-information</v-icon>
      {{ getText(item.status) }}
    </v-btn>
    <v-dialog v-model="isOpenInfo" width="50vw" scrollable>
      <v-card v-if="isOpenInfo" height="600px">
        <v-card-text>
          <pre v-html="info"></pre>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="isOpenInfo = false" color="primary">{{ $lang('main.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const translations = {
  0: 'Creata',
  1: 'Esportata',
  2: 'Accodata',
  3: 'Inviata',
  4: 'Scartata',
  5: 'Consegnata',
  6: 'Mancata consegna',
}

import {
  GET_COMPANY_INVOICES_SINGLE
} from '@/store/company-invoices/actions';

export default {
  props: {
    item: {
      required: false,
      default: null,
    }
  },
  data() {
    return {
      info: null,
      isOpenInfo: false,
      loading: false,
    }
  },
  methods: {
    async getItem() {
      this.loading = true;
      await this.$store.dispatch(GET_COMPANY_INVOICES_SINGLE, {
        id: this.item.id
      }).then(response => {
        this.info = response.xml;
      });

      this.loading = false;
    },
    async openInfo() {
      await this.getItem();
      this.isOpenInfo = true;
    },
    getText(value) {
      return translations[value];
    }
  },
  computed: {
    chipColor() {
      if (!this.item.status) return null;

      if (this.isError) {
        return 'error';
      }

      if (this.isSuccess) {
        return 'success';
      }

      if (this.isWarning) {
        return 'warning';
      }

      return null;
    },
    isError() {
      return this.errors.includes(this.item.status);
    },
    isSuccess() {
      return this.success.includes(this.item.status);
    },
    isWarning() {
      return this.warning.includes(this.item.status);
    },
    errors() {
      return [
        this.$const('ConstCompanyInvoiceStatuses', 'REJECTED')
      ]
    },
    success() {
      return [
        this.$const('ConstCompanyInvoiceStatuses', 'DELIVERED'),
        this.$const('ConstCompanyInvoiceStatuses', 'EXPORTED'),
        this.$const('ConstCompanyInvoiceStatuses', 'UNDELIVERABLE'),
      ]
    },
    warning() {
      return [
        this.$const('ConstCompanyInvoiceStatuses', 'SENT'),
        this.$const('ConstCompanyInvoiceStatuses', 'QUEUED'),
      ]
    },
  }
}
</script>